import './home.scss';

import Sidebar from '../../components/Sidebar/sidebar';
import ScrollToTopIcon from "../../components/ScrollToTopIcon/scrollToTopIcon";
import { MobileMenuFooter } from "../Sidebar/MobileMenu/mobileMenu";

const Home = ({ Component }) => {

    return (
        <div style={{
            position: 'relative',
            display: 'flex',
            transition: 'ease-in 0.5s',
        }}>
            <Sidebar />
            <div className='blueBackground'>
                <Component />
                <MobileMenuFooter />
            </div>
            <ScrollToTopIcon />
        </div>
    )
}

export default Home;